import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

//importing context
import { useLocalStorage } from '../contexts/LocalStorage';

//importing theme pages
import { Login } from "../modules/login/pages/login";
import { Dashboard } from "../modules/dashboard/pages";
import { StartScreen } from "../pages/startScreen";

import { NovoPedido } from "../modules/pedidos/pages/novo_pedido";
import { ConsultarPedidos } from "../modules/pedidos/pages/consultar_pedidos";
import { ConsultarPrePedidos } from "../modules/pedidos/pages/consultar_prepedidos";

import { NovoCliente } from "../modules/clientes/pages/novo_cliente";
import { ConsultarClientes } from "../modules/clientes/pages/consultar_clientes";

import { AprovarPedidos } from "../modules/aprovacao/pages/aprovar_pedidos";

import { Perfil } from "../modules/gerenciamento_usuario/pages/perfil";

import { PageNotFound } from "../pages/PageNotFound";
import { useAuth } from '../contexts/Auth';

import { RVPE620 } from "../modules/relatorios/pages/Pedidos/RVPE620";
import { RVPE571 } from "../modules/relatorios/pages/Pedidos/RVPE571";
import { RVPE558 } from "../modules/relatorios/pages/Pedidos/RVPE558";
import { RVPE461 } from "../modules/relatorios/pages/Pedidos/RVPE461";
 
import { RFNF520 } from "../modules/relatorios/pages/Faturamento/RFNF520";
 
import { SECE500 } from "../modules/relatorios/pages/Estoque/SECE500";
import { PANT001 } from "../modules/relatorios/pages/Estoque/PANT001";
 
import { DSCF208 } from "../modules/relatorios/pages/Cadastros/DSCF208";
 
import {FRCR898} from "../modules/relatorios/pages/Financeiro/FRCR898";


const PrivateRoute = ({ component: Component, ...rest }) => {
    const { getFromSessionStorage } = useLocalStorage();
    return (
        <Route
            {...rest}
            render={props => (
                getFromSessionStorage("logid") !== undefined && getFromSessionStorage("logid") !== null ? (<Component {...props} />) : (<Redirect to={{ pathname: `${process.env.PUBLIC_URL}/login`, state: { from: props.location.pathname } }} />)
            )}
        />
    )
};

const PrivateRouteAdmin = ({ component: Component, ...rest }) => {
    const { getFromSessionStorage } = useLocalStorage();
    const { user } = useAuth();

    return (
        <Route
            {...rest}
            render={props => (
                getFromSessionStorage("logid") !== undefined && getFromSessionStorage("logid") !== null && user.role === "RSU"? (<Component {...props} />) : (<Redirect to={{ pathname: `${process.env.PUBLIC_URL}/login`, state: { from: props.location.pathname } }} />)
            )}
        />
    )
};


const Routes = () => {
    return (
        <Switch>
            <Route exact path={`${process.env.PUBLIC_URL}/login`} component={Login} />
            <Route exact path={`${process.env.PUBLIC_URL}/`} component={Login} />
            <PrivateRoute exact path={`${process.env.PUBLIC_URL}/dashboard`} component={Dashboard} />
            <PrivateRoute exact path={`${process.env.PUBLIC_URL}/inicio`} component={StartScreen} />

            <PrivateRoute exact path={`${process.env.PUBLIC_URL}/pedidos`} component={ConsultarPedidos} />
            <PrivateRoute exact path={`${process.env.PUBLIC_URL}/pedidos/consultar`} component={ConsultarPedidos} />
            <PrivateRoute exact path={`${process.env.PUBLIC_URL}/prepedidos/consultar`} component={ConsultarPrePedidos} />
            <PrivateRoute exact path={`${process.env.PUBLIC_URL}/pedidos/novo`} component={NovoPedido} />

            <PrivateRoute exact path={`${process.env.PUBLIC_URL}/clientes`} component={ConsultarClientes} />
            <PrivateRoute exact path={`${process.env.PUBLIC_URL}/clientes/novo`} component={NovoCliente} />
            <PrivateRoute exact path={`${process.env.PUBLIC_URL}/clientes/consultar`} component={ConsultarClientes} />

            <PrivateRoute exact path={`${process.env.PUBLIC_URL}/usuario/perfil`} component={Perfil} />

            <PrivateRoute exact path={`${process.env.PUBLIC_URL}/relatorios/pedidos/RVPE461`} component={RVPE461} />
            <PrivateRoute exact path={`${process.env.PUBLIC_URL}/relatorios/pedidos/RVPE620`} component={RVPE620} />
            <PrivateRoute exact path={`${process.env.PUBLIC_URL}/relatorios/pedidos/RVPE571`} component={RVPE571} />
            <PrivateRoute exact path={`${process.env.PUBLIC_URL}/relatorios/pedidos/RVPE558`} component={RVPE558} />
            
            <PrivateRoute exact path={`${process.env.PUBLIC_URL}/relatorios/faturamento/RFNF520`} component={RFNF520} />
            <PrivateRoute exact path={`${process.env.PUBLIC_URL}/relatorios/estoque/SECE500`} component={SECE500} />
            <PrivateRoute exact path={`${process.env.PUBLIC_URL}/relatorios/estoque/PANT001`} component={PANT001} />
            <PrivateRoute exact path={`${process.env.PUBLIC_URL}/relatorios/cadastros/DSCF208`} component={DSCF208} />
            <PrivateRoute exact path={`${process.env.PUBLIC_URL}/relatorios/financeiro/FRCR898`} component={FRCR898} />

            <PrivateRouteAdmin exact path={`${process.env.PUBLIC_URL}/aprovacao`} component={AprovarPedidos} />

            <Redirect to={`${process.env.PUBLIC_URL}/PageNotFound`} /> 
        </Switch>
    );
}

export default Routes;